import { useState } from "react";
import { toast } from "react-hot-toast";
import { useStationManagementApi } from "../../hooks/useStationManagement";

// Shared activate/deactivate flow with a confirmation step.
// Returns { request, dialogProps } — spread dialogProps onto <ConfirmDialog />.
export function useStatusToggle({ entity, describe, onChanged }) {
  const api = useStationManagementApi();
  const [target, setTarget] = useState(null); // { id, next, label, warning }
  const [busy, setBusy] = useState(false);

  const request = (record) => setTarget(describe(record));

  const confirm = async () => {
    if (!target || busy) return;
    setBusy(true);
    try {
      await api.setStatus(entity, target.id, target.next);
      toast.success(`${target.label} is now ${target.next}`);
      onChanged?.(target.id, target.next);
      setTarget(null);
    } catch (err) {
      toast.error(err.message || "Could not change the status");
    } finally {
      setBusy(false);
    }
  };

  const activating = target?.next === "active";
  return {
    request,
    dialogProps: {
      open: Boolean(target),
      loading: busy,
      title: target ? `${activating ? "Activate" : "Deactivate"} ${target.label}?` : "",
      message: target ? (activating ? `${target.label} will be marked active.` : `${target.label} will be marked inactive. ${target.warning || ""}`) : "",
      confirmLabel: activating ? "Activate" : "Deactivate",
      tone: activating ? "primary" : "danger",
      onCancel: () => !busy && setTarget(null),
      onConfirm: confirm,
    },
  };
}
